import { Link2, Loader2, Mail, RefreshCw } from "lucide-react";
import { trpc } from "@/lib/trpc";
import { envioDoExtrato } from "@/components/financeiro/extratos/situacao";
import { useEnvioDoExtrato } from "./use-envio-do-extrato";

const botao =
  "inline-flex h-9 w-full items-center justify-center gap-1.5 rounded-md border border-zinc-200 px-3 text-sm font-medium text-zinc-700 hover:bg-zinc-50 disabled:opacity-50 dark:border-border dark:text-foreground dark:hover:bg-muted/40";

type Extrato = { id: string; numero: number; enviadoEm: Date | string | null; enviadoPara: string | null; visualizadoEm: Date | string | null };

/** No extrato emitido: mandar (ou mandar de novo) por e-mail, copiar o link e trocar o link. */
export function EnvioDoExtrato({ extrato: e }: { extrato: Extrato }) {
  const destino = trpc.financeiro.envio.destino.useQuery({ extratoId: e.id }).data;
  const { enviar, link, novoLink } = useEnvioDoExtrato();

  return (
    <div className="space-y-2 border-t border-zinc-100 pt-3 dark:border-border">
      <p className="text-xs font-semibold uppercase tracking-wide text-zinc-500 dark:text-muted-foreground">Envio</p>
      <p className="text-xs text-zinc-600 dark:text-muted-foreground">
        {envioDoExtrato(e)}
        {e.enviadoPara && ` · ${e.enviadoPara}`}
      </p>
      <button
        type="button"
        disabled={!destino || enviar.isPending}
        onClick={() => destino && window.confirm(`Enviar o extrato nº ${e.numero} para ${destino.exibicao}?`) && enviar.mutate({ extratoId: e.id })}
        className={botao}
      >
        {enviar.isPending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />}
        {e.enviadoEm ? "Reenviar por e-mail" : "Enviar por e-mail"}
      </button>
      {destino === null && <p className="text-[11px] font-semibold text-amber-600">Sem e-mail: cadastre o e-mail da cobrança no perfil do cliente.</p>}
      <button type="button" disabled={link.isPending} onClick={() => link.mutate({ extratoId: e.id })} className={botao}>
        <Link2 className="h-4 w-4" />
        Copiar link
      </button>
      <button
        type="button"
        disabled={novoLink.isPending}
        onClick={() => window.confirm("Gerar um link novo? O link que já foi mandado deixa de abrir.") && novoLink.mutate({ extratoId: e.id })}
        className="inline-flex w-full items-center justify-center gap-1.5 text-[11px] text-zinc-500 hover:text-zinc-800 dark:text-muted-foreground dark:hover:text-foreground"
      >
        <RefreshCw className="h-3 w-3" />
        Gerar novo link
      </button>
    </div>
  );
}
